import { useState, useEffect } from 'react';

const useDebounceWithCallback = <T>(
  value: T,
  callback: () => void,
  delay = 1000,
) => {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
        callback();
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay, callback], // Only re-call effect if value or delay changes
  );
  return debouncedValue;
};

export default useDebounceWithCallback;
